import service from "@/store/services/summaries-service";

const state = {
  list: [],
  summary: {},
  meta: { page: { total: 0 } },
  url: null
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, summary) => {
    state.summary = summary;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

const actions = {
  list({ commit }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit }, params) {
    return service.get(params).then(summary => {
      commit("SET_RESOURCE", summary);
    });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  summary: state => state.summary,
  url: state => state.url
};

const summaries = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default summaries;
